import { CommonModule, DatePipe, DecimalPipe } from "@angular/common";
import { HistoricoPesquisaComponent } from "./historico-pesquisa/historico-pesquisa.component";
import { HistoricoTabComponent } from "./historico-tab/historico-tab.component";

import { AutocompleteModule, DatepickerModule, PaginationMapsModule } from "maps-angular-components";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {PaginationModule, TabsModule, TooltipModule} from "ngx-bootstrap";

import { CarteiraModule } from "../carteira/carteira.module";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import {MatMenuModule} from '@angular/material/menu';
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";
import { NgModule } from "@angular/core";
import { RegraModule } from "../regra/regra.module";
import { SharedModule } from "../shared/shared.module";
import { CarteiraAutocompleteModule } from "../shared/components/carteira-autocomplete/carteira-autocomplete.module";
import { HistoricoService } from "./historico.service";
import { HistoricoParametrosComponent, HistoricoParametrosDialogComponent } from "./historico-parametros-modal/historico-parametros-modal";
import { HistoricoErroComponent, HistoricoErroDialogComponent } from "./historico-erro-modal/historico-erro-modal";


@NgModule({
  declarations: [
    HistoricoPesquisaComponent,
    HistoricoTabComponent,
    HistoricoParametrosComponent,
    HistoricoParametrosDialogComponent,
    HistoricoErroComponent,
    HistoricoErroDialogComponent
  ],
    imports: [
              CommonModule,
              TabsModule,
              CarteiraModule,
              RegraModule,
              SharedModule,
              DatepickerModule,
              MatSelectModule,
              MatDialogModule,
              MatTableModule,
              MatButtonModule,
              MatIconModule,
              MatMenuModule,
              PaginationMapsModule,
              PaginationModule,
              FormsModule,
              AutocompleteModule,
              CarteiraAutocompleteModule,
              TooltipModule,
              ReactiveFormsModule
    ],
  providers: [DatePipe, DecimalPipe],
})
export class HistoricoModule {}
